import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CyberSecurityAuditRequestComponent } from './cyber-security-audit-request/cyber-security-audit-request.component';
import { SharedModule } from '../../../../shared/shared.module';
import { NgxSpinnerModule } from 'ngx-spinner';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { DataTablesModule } from 'angular-datatables';
import { EnitComplainceRoutingModule } from '../../eComplaince-routing.module';
import { HighchartsChartModule } from 'highcharts-angular';
import { BaseChartDirective } from 'ng2-charts';
import { AgGridModule } from 'ag-grid-angular';
import { CtclModule } from '../../EnitTrade/ctcl/ctcl.module';
import { TradeAdminRoutingModule } from '../../tradeAdmin-routing.module';
import { CyberSecurityAuditEligibleUserComponent } from './cyber-security-audit-eligible-user/cyber-security-audit-eligible-user.component';
import { AddCyberSecurityAuditEligibleUserComponent } from './add-cyber-security-audit-eligible-user/add-cyber-security-audit-eligible-user.component';
import { CyberSecurityAuditAdminListComponent } from './cyber-security-audit-report-list/cyber-security-audit-admin-list.component';


@NgModule({
  declarations: [
    CyberSecurityAuditRequestComponent,
    CyberSecurityAuditEligibleUserComponent,
    AddCyberSecurityAuditEligibleUserComponent,
    CyberSecurityAuditAdminListComponent
  ],
  
  imports: [
    CommonModule,
    TradeAdminRoutingModule,
    FormsModule,
    DataTablesModule,
    ReactiveFormsModule,
    NgxSpinnerModule,
    BsDatepickerModule,
    SharedModule,
    CtclModule,
    EnitComplainceRoutingModule,
    AgGridModule,
    BaseChartDirective,
    HighchartsChartModule
  ]
})

export class CyberSecurityAuditModule { }